// extracted by mini-css-extract-plugin
module.exports = {"cashflow_svg":"CashFlowSVG_cashflow_svg__gP5P8","shrink-figure":"CashFlowSVG_shrink-figure__5Ibpm"};